export default __webpack_public_path__ + "static/media/whatsapp.4df94953.svg";